import {
  FORGOT_PASSWORD_FAILURE,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  GOOGLE_SIGN_IN_FAILURE,
  GOOGLE_SIGN_IN_REQUEST,
  GOOGLE_SIGN_IN_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT,
  LOGOUT_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  RESET_FORGOT_PASSWORD_STATE,
  RESET_LOGIN_FORM_STATE,
  RESET_PASSWORD_FAILURE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_STATE,
  RESET_PASSWORD_SUCCESS,
  RESET_VERIFY_EMAIL_STATE,
  VERIFY_EMAIL_FAILURE,
  VERIFY_EMAIL_REQUEST,
  VERIFY_EMAIL_SUCCESS,
} from "../types/AuthTypes";

export const loginRequest = (credentials) => ({
  type: LOGIN_REQUEST,
  payload: credentials,
});

export const loginSuccess = (user) => ({
  type: LOGIN_SUCCESS,
  payload: user,
});

export const loginFailure = (error) => ({
  type: LOGIN_FAILURE,
  payload: error,
});

export const googleSignInRequest = (credentials) => ({
  type: GOOGLE_SIGN_IN_REQUEST,
  payload: credentials,
});



export const logoutRequest = () => ({
  type: LOGOUT_REQUEST,
});

export const logoutSuccess = () => ({
  type: LOGOUT_SUCCESS,
});

export const logoutFailure = (error) => ({
  type: LOGOUT_FAILURE,
  payload: error,
});

export const clearError = () => ({
  type: "CLEAR_ERROR",
});

export const resetUserLoginState = () =>({
  type: "RESET_USER_LOGIN_STATE"
})

export const forgotPasswordRequest = (email) => ({
  type: FORGOT_PASSWORD_REQUEST,
  payload: email,
});

export const forgotPasswordSuccess = (message) => ({
  type: FORGOT_PASSWORD_SUCCESS,
  payload: message,
});

export const forgotPasswordFailure = (error) => ({
  type: FORGOT_PASSWORD_FAILURE,
  payload: error,
});

export const verifyEmailRequest = (payload) => ({
  type: VERIFY_EMAIL_REQUEST,
  payload,
});

export const verifyEmailSuccess = (message) => ({
  type: VERIFY_EMAIL_SUCCESS,
  payload: message,
});

export const verifyEmailFailure = (error) => ({
  type: VERIFY_EMAIL_FAILURE,
  payload: error,
});

export const resetPasswordRequest = (email) => ({
  type: RESET_PASSWORD_REQUEST,
  payload: email,
});

export const resetPasswordSuccess = (message) => ({
  type: RESET_PASSWORD_SUCCESS,
  payload: message,
});

export const resetPasswordFailure = (error) => ({
  type: RESET_PASSWORD_FAILURE,
  payload: error,
});

export const resetVerifyEmailState = () => ({
  type: RESET_VERIFY_EMAIL_STATE,
});
export const resetForgotPasswordState = () => ({
  type: RESET_FORGOT_PASSWORD_STATE,
});
export const resetLoginFormState = () => ({
  type: RESET_LOGIN_FORM_STATE,
});
export const resetPasswordState = () => ({
  type: RESET_PASSWORD_STATE,
});
